import { useActor } from '@xstate/react';
import { TransferView } from './TransferView';
import { TransferMachineActor } from '../../../machines/RedeemArtistInvitation/TransferMachine';

export function TransferController({ actor }: { actor: TransferMachineActor }) {
  const [state, send] = useActor(actor);

  return <TransferView state={state} send={send} />;
}
